module.exports = __webpack_public_path__ + "public/img/椭圆7.a8dfef95.png";